import React from "react";
import ReactDOM from "react-dom";
import { FaExclamationTriangle, FaTimes, FaTrash } from "react-icons/fa";

export default function TaskDeleteModal({ task, onClose, onConfirm }) {
  if (!task) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-slate-950/75 px-4 py-6 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose?.();
      }}
    >
      <div className="w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-slate-200 bg-slate-50 px-5 py-4">
          <div className="flex items-center gap-3">
            <div className="grid h-11 w-11 place-items-center rounded-2xl bg-red-100 text-red-600">
              <FaExclamationTriangle />
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900">
                Supprimer cette tâche ?
              </h3>
              <p className="text-sm text-slate-500">
                Cette action est définitive.
              </p>
            </div>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="grid h-10 w-10 place-items-center rounded-full text-slate-500 transition hover:bg-slate-200"
          >
            <FaTimes />
          </button>
        </div>

        <div className="p-5">
          <p className="text-sm text-slate-600">
            Tu vas supprimer définitivement :
          </p>

          <div className="mt-3 rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm font-bold text-slate-900">
            {task.titre || "Tâche sans titre"}
          </div>
        </div>

        <div className="flex justify-end gap-2 border-t border-slate-200 bg-slate-50 px-5 py-4">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex min-h-[42px] items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-100"
          >
            <FaTimes />
            Annuler
          </button>

          <button
            type="button"
            onClick={onConfirm}
            className="inline-flex min-h-[42px] items-center gap-2 rounded-xl bg-red-600 px-4 py-2 text-sm font-bold text-white transition hover:bg-red-700"
          >
            <FaTrash />
            Supprimer
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}